import { IdentifiantAdressageData } from './identifiantAdressageData';

export class IdentifiantsAdressageResponse {
  identifiantAdressageList: IdentifiantAdressageData[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  httpStatusCode: number;
}
